(function() {
	'use strict';

	angular.module('smb-app')
		.factory('smbContentTypeAcls', [
			'SMB_RIGHTS_TYPE',
			'SMB_RIGHTS',
			function(SMB_RIGHTS_TYPE, SMB_RIGHTS) {
				return {
					VIEW_RIGHTS: SMB_RIGHTS[SMB_RIGHTS_TYPE.viewRights].param,
					FULL_RIGHTS: SMB_RIGHTS[SMB_RIGHTS_TYPE.fullRights].param,
					EDIT_RIGHTS: SMB_RIGHTS[SMB_RIGHTS_TYPE.editRights].param,
					READ_DOCUMENTS: 16,
					CREATE_DOCUMENTS: 8,
					MODIFY_DOCUMENTS: 2
				};
			}
		]);
}());


//////////////////
// WEBPACK FOOTER
// ./app/services/contentTypeAcls.js
// module id = 141
// module chunks = 1